import { Controller } from "@hotwired/stimulus"
import BSModal from "bootstrap/js/dist/Modal"

export default class extends Controller {
    static values = { opened: Boolean }

    connect() {
        if (!this.hasOpened()) {
            this.open()
        }
    }

    disconnect() {
        if (this.hasOpened()) {
            this.close();
        }
    }

    open() {
        this.openedValue = true
        this.modal = new BSModal(this.element, {
            keyboard: false
        })
        this.modal.show()
    }

    hasOpened() {
        return this.openedValue
    }

    close() {
        this.modal.destroy()
        this.openedValue = false

    }
}
